// Libraries
var React = require('react');

require('./VoucherCode.scss');

class VoucherCode extends React.Component {
	constructor(props) {

		super(props);

		this.defaultMParticleEventObject = (typeof window !== "undefined") ? window.defaultMParticleEventObject : null;

		this.state = {
			revealed: false,
			copied: false
		}

	}

	handleReveal() {

		this.setState({ revealed: true });

		this.triggerMParticleEvent('code_revealed');

	}

	handleCopy() {

		navigator.clipboard.writeText(this.props.code);
		this.setState({ copied: true });
		setTimeout(() => { this.setState({ copied: false }); }, 2000);

		this.triggerMParticleEvent('code_copied');

	}

	triggerMParticleEvent(eventName) {

		if (this.defaultMParticleEventObject) {

			const eventData = {
				event: eventName,
				business_line: this.props.businessLine
			};

			const eventDataMerged = { ...this.defaultMParticleEventObject, ...eventData };
			window.dataLayer.push(eventDataMerged);

		}

	}

	render() {
        const buttonClasses = this.props.alternateStyle ? 'c-button c-button--dark' : 'c-button c-button--on-dark c-button--small';
		return (
			<div className={`c-voucher-code${this.props.alternateStyle ? " c-voucher-code--alternate" : ""}`} id={this.props.code}>
				<div className="c-voucher-code__inner">

					{this.props.redeemed &&
						<p className="c-voucher-code__redeemed" aria-label="You have redeemed this gift">
							<span className="c-voucher-code__redeemed__inner">Redeemed</span>
						</p>
					}

					{!this.props.redeemed &&
						<div>
							{!this.state.revealed &&
								<button type="button" className={buttonClasses} onClick={this.handleReveal.bind(this)}>{this.props.redeemCtaText}</button>
							}
							{this.state.revealed &&
								<div className="c-voucher-code__copy">
									<p className="c-voucher-code__copy__content">{this.props.code}</p>
									{!this.state.copied &&
										<button type="button" className="c-voucher-code__copy__button" aria-label="Copy code to clipboard" onClick={this.handleCopy.bind(this)}>
											<span className="c-voucher-code__copy__button__inner">Copy<span className="c-voucher-code__copy__button__inner__suffix"> code</span></span>
										</button>
									}
									{this.state.copied &&
										<p className="c-voucher-code__copy__message">
											<span className="c-voucher-code__copy__message__inner" role="status">Copied<span className="u-visually-hidden"> code to clipboard</span></span>
										</p>
									}
								</div>
							}
						</div>
					}
				</div>

				{(this.props.cta && this.props.cta.url && this.props.cta.url !== "" && this.props.cta.caption && this.props.cta.caption !== "" && !this.props.alternateStyle) &&
					<p className="c-voucher-code__link">
						<a href={this.props.cta.url} className={buttonClasses} target={this.props.cta.newWindow ? "_blank" : "_self"} rel={this.props.cta.newWindow ? "noopener noreferrer" : undefined}>{this.props.cta.caption}</a>
					</p>
				}
			</div>
		);
	}
};

module.exports = VoucherCode;


// WEBPACK FOOTER //
// ./src/components/VoucherCode/VoucherCode.js